import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const businessViewPlugin: FrontendPlugin = createFrontendPlugin({
  extensions: [
    EntityContentBlueprint.make({
      name: 'business-view',
      params: {
        filter: { 'kind': 'system', 'spec.type': 'solution' },
        group: 'business-view',
        loader: async () => {
          const { BusinessView } = await import('./components/BusinessView');
          return <BusinessView />;
        },
        path: '/business-view',
        title: 'Business View',
      },
    }),
  ],
  pluginId: 'business-view',
});
